const HeadingBlock = ({
  subtitle,
  title,
  highlight,
  subtitleColor = "text-gray-500",
  titleColor = "text-green-950",
  highlightColor = "text-[#fb923c]",
  lineColor = "bg-green-600", // Decorative line color
  align = "left", // "left" | "center" | "right"
}) => {
  // Alignment mapping
  const alignMap = {
    left: "text-left justify-start",
    center: "text-center justify-center",
    right: "text-right justify-end",
  };

  return (
    <div className={`${alignMap[align].split(" ")[0]}`}>
      {/* Subtitle */}
      <p
        className={`text-sm tracking-[0.3em] uppercase mb-2 ${subtitleColor} ${alignMap[align].split(" ")[0]}`}
      >
        {subtitle}
      </p>

      {/* Title with Highlight */}
      <h2
        className={`text-3xl md:text-4xl font-bold ${titleColor} ${alignMap[align].split(" ")[0]}`}
      >
        {title}{" "}
        <span className={`${highlightColor}`}>{highlight}</span>
      </h2>

      {/* Decorative underline lines */}
      <div className={`flex space-x-2 mt-3 ${alignMap[align].split(" ")[1]}`}>
        {/* Small line */}
        <div className={`w-3 h-1 rounded-full ${lineColor}`}></div>
        {/* Big line */}
        <div className={`w-16 h-1 rounded-full ${lineColor}`}></div>
      </div>
    </div>
  );
};

export default HeadingBlock;
